module.exports = __webpack_public_path__ + "img/header_5.f57c224c.jpg";